import { DEFAULT_STORE } from 'shared/constants/store';

// Unmatched routes are intentionally guest-accessible. Add a pattern only
// when the route owns authenticated customer data and cannot render as guest.
const PROTECTED_ROUTE_PATTERNS = [
  /^\/wishlist(?:\/.*)?$/,
  /^\/address-book(?:\/.*)?$/,
  /^\/delete-account(?:\/.*)?$/,
  /^\/product-rating(?:\/.*)?$/,
  /^\/flx-summary(?:\/.*)?$/,
  /^\/my\/orders(?:\/.*)?$/,
  /^\/sales\/order(?:\/.*)?$/,
  /^\/v2\/checkout\/address(?:\/.*)?$/,
  /^\/v2\/address(?:\/.*)?$/,
  /^\/(?:v2|v3)\/payment(?:\/.*)?$/,
  /^\/checkout\/payment(?:\/.*)?$/,
];

export const normalizePathname = (pathname: string): string => {
  const normalizedPathname = pathname.replace(/\/+$/, '');

  return normalizedPathname || '/';
};

const stripCurrentStorePrefix = (pathname: string, storeId?: string): string => {
  const normalizedPathname = normalizePathname(pathname);

  if (!storeId || storeId === DEFAULT_STORE) {
    return normalizedPathname;
  }

  const storePrefix = `/${storeId}`;
  if (normalizedPathname === storePrefix) {
    return '/';
  }

  return normalizedPathname.startsWith(`${storePrefix}/`)
    ? normalizedPathname.slice(storePrefix.length)
    : normalizedPathname;
};

export const shouldRedirectHomeAfterAuthRecovery = (
  pathname: string,
  storeId?: string
): boolean => {
  const normalizedPathname = stripCurrentStorePrefix(pathname, storeId);

  return PROTECTED_ROUTE_PATTERNS.some((pattern) => pattern.test(normalizedPathname));
};
